import { render, staticRenderFns } from "./AttentionChart.vue?vue&type=template&id=455828e9&scoped=true&"
import script from "./AttentionChart.vue?vue&type=script&lang=js&"
export * from "./AttentionChart.vue?vue&type=script&lang=js&"
import style0 from "./AttentionChart.vue?vue&type=style&index=0&id=455828e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455828e9",
  null
  
)

export default component.exports